export default "__VITE_ASSET__CN$GrrEM__"